module.exports = __webpack_public_path__ + "./images/676c48285f0a2ef7888653d5b186dc92.webp";